import './index_mWeb.css';
import { useEffect, useState } from 'react';
import { View, Text, Card, GadgetLeague } from '../../../component';
import { convertToDollars, isGadgetLeague } from '../../../utilities/helper';
import Constants from '../../../constants';
import I18n from '../../../utilities/locale';
import React from 'react';
import useGame from '../../../utilities/hooks/game';

interface Props {
  onPressCard: any;
  contest: any;
  myTeamList: any[];
  matchVerifiedStatus: boolean;
}
const ContestResultCard = ({
  onPressCard,
  contest,
  myTeamList = [],
  matchVerifiedStatus = false
}: Props) => {
  const [bestContestScore, setBestContestScore] = useState(0 as number);
  const [bestRank, setBestRank] = useState(0);
  const [totalWinnings, setTotalWinnings] = useState(0);
  const [teamNumberData, setTeamNumberData] = useState(0 as any);
  const { item: matchItem } = useGame();
  const {
    entryFee = 0,
    winningsPerPosition = {},
    contestTeams = [],
    _id: contestId = '',
    winningsAmount = 0,
    title = '',
    description = ''
  } = contest;

  const isGadgetLeague_ = isGadgetLeague(title);

  useEffect(() => {
    let contestScore = 0;
    let winningAmount = 0;
    let teamNumberData = '';

    let bestRank = Math.min.apply(
      null,
      contestTeams.map(function (item: { rank: number }) {
        return item.rank;
      })
    );

    contestTeams.forEach((item: { contestId: any; winning: number; matchTeamId: any }) => {
      if (item.contestId === contestId) {
        if (item.winning > 0) winningAmount = winningAmount + item.winning;
        let teamObjIndex = myTeamList[matchItem._id].findIndex(
          (x: any) => x.id === item.matchTeamId
        );
        if (teamObjIndex !== -1) {
          teamNumberData =
            teamNumberData + 'T' + myTeamList[matchItem._id][teamObjIndex].teamNumber + ' ';
          if (
            myTeamList[matchItem._id][teamObjIndex] &&
            (myTeamList[matchItem._id][teamObjIndex].score > contestScore ||
              (myTeamList[matchItem._id][teamObjIndex].verifiedScore &&
                myTeamList[matchItem._id][teamObjIndex].verifiedScore > contestScore))
          ) {
            contestScore = myTeamList[matchItem._id][teamObjIndex].verifiedScore
              ? myTeamList[matchItem._id][teamObjIndex].verifiedScore
              : myTeamList[matchItem._id][teamObjIndex].score;
          }
        }
      }
    });
    setBestRank(bestRank);
    setTeamNumberData(teamNumberData);
    setBestContestScore(contestScore);
    setTotalWinnings(winningAmount);
  }, [winningsPerPosition, contestTeams, myTeamList]);

  let noOfWinners = 0;
  for (let key in winningsPerPosition) {
    noOfWinners += winningsPerPosition[key];
  }

  const winningsAmountValue = `${convertToDollars(winningsAmount / 100)}`;

  const surfaceColor = {
    backgroundColor: '#222d3b'
  };

  const titleTextColor = {
    color: '#fff'
  };

  const valueTextColor = {
    color: '#fff'
  };

  const cardMiddleWrapperColor = {
    borderColor: '#596779'
  };

  const separatorColor = {
    borderBottomColor: '#596779'
  };

  const prizePool = {
    color: '#26ae5f'
  };

  const leaderboardText = {
    color: '#fff'
  };

  return (
    <Card
      style={surfaceColor}
      onPress={onPressCard}
      className={'contest-result-card-container_mWeb '}>
      <View className={'contest-result-card-wrapper_mWeb'}>
        <View className={'contest-result-card-left-wrapper_mWeb'}>
          <Text className={'contest-result-card-title-text_mWeb'} style={titleTextColor}>
            {I18n.t('PricePool')}
          </Text>
          {isGadgetLeague_ ? (
            <GadgetLeague
              titleClassName="contest-result-card-value-text_mWeb"
              titleStyle={prizePool}
              description={description}
            />
          ) : (
            <Text
              className={'contest-result-card-value-text_mWeb'}
              style={{ color: '#ffce00' }}>{`${winningsAmountValue}`}</Text>
          )}
        </View>
        <View className={'contest-result-card-middle-wrapper_mWeb'} style={cardMiddleWrapperColor}>
          <Text className={'contest-result-card-title-text_mWeb '} style={titleTextColor}>
            {I18n.t('Winners')}
          </Text>
          <Text className={'contest-result-card-value-text_mWeb'} style={valueTextColor}>
            {noOfWinners}
          </Text>
        </View>
        <View className={'contest-result-card-right-wrapper_mWeb'}>
          <Text className={'contest-result-card-title-text_mWeb '} style={titleTextColor}>
            {I18n.t('EntryFee')}
          </Text>
          <Text
            className={'contest-result-card-value-text_mWeb'}
            style={valueTextColor}>{`${convertToDollars(entryFee / 100)}`}</Text>
        </View>
      </View>
      <View className={'contest-result-card-separator_mWeb'} style={separatorColor} />
      <View className={'contest-result-card-wrapper_mWeb'}>
        <View className={'contest-result-card-left-wrapper_mWeb'}>
          <Text className={'contest-result-card-title-text_mWeb '} style={titleTextColor}>
            {I18n.t('JoinedWith')}
          </Text>
          <Text
            className={'contest-result-card-value-text_mWeb'}
            style={valueTextColor}>{`${teamNumberData}`}</Text>
        </View>
        <View className={'contest-result-card-middle-wrapper_mWeb'} style={cardMiddleWrapperColor}>
          <Text className={'contest-result-card-title-text_mWeb '} style={titleTextColor}>
            {I18n.t('Points')}
          </Text>
          <Text className={'contest-result-card-value-text_mWeb'} style={valueTextColor}>
            {bestContestScore}
          </Text>
        </View>
        <View className={'contest-result-card-right-wrapper_mWeb'}>
          <Text className={'contest-result-card-title-text_mWeb '} style={titleTextColor}>
            {I18n.t('Rank')}
          </Text>
          <Text
            className={'contest-result-card-value-text_mWeb'}
            style={valueTextColor}>{`#${bestRank}`}</Text>
        </View>
      </View>
      <View className={'contest-result-card-separator_mWeb'} style={separatorColor} />
      <View className={'contest-result-card-bottom-wrapper_mWeb'}>
        {totalWinnings > 0 && matchVerifiedStatus && (
          <View className={'contest-result-card-winning-amt-container_mWeb'}>
            <Constants.Svgs.MoneyIcon width={25} height={25} fill={'#ffce00'} />
            <Text
              className={'contest-result-card-winning-amt-title_mWeb'}
              style={{
                color: '#ffce00'
              }}>
              {`${convertToDollars(totalWinnings / 100)}`}
            </Text>
          </View>
        )}

        <View className={'contest-result-card-footer-container_mWeb '}>
          <View className={'contest-result-card-footer-leaderboard-btn_mWeb'}>
            <Text className={'contest-result-card-leaderboard-text_mWeb'} style={leaderboardText}>
              {'View Leaderboard'}
            </Text>
            <Constants.Svgs.ViewLeaderBoard height={15} width={10} fill={'#fff'} />
          </View>
        </View>
      </View>
    </Card>
  );
};
export default React.memo(ContestResultCard);
